
<template>
<b-overlay opacity="0.75" spinner-variant="primary" :show="$root.$data.bsLoader">
  <div class="body-wrapper">
    <nav-bar />
    <b-container class="position-relative strata-table contacts" fluid>
      <div class="main-panel">
        <div class="db-content-wrapper">
          <h4 class="page-title mt-4">My Contacts Lists</h4>
          <div class="tbl-ct mt-4">
              <div class="position-relative f-b">
                <i class="fas fa-search search-icon"></i>
                <b-form-input
                  class="mb-2 mb-sm-0"
                  placeholder=""
                  v-model="filterQuery"
                  @change="filter(1)"
                ></b-form-input>
              </div>

              <b-button
                v-b-modal.modal-center
                variant="primary"
                class="adjust"
                @click="addContactModal()"
                >Add Contact</b-button
              >
          </div>

          <!-- Add Contact Modal -->
          <div>
            <b-modal
              id="modal-center"
              size="xl"
              centered
              :hide-footer="true"
              :style="{ padding: '6px' }"
              v-if="showAddContactModal"
            >
             <template #modal-title>
                Add Contact
            </template>

              <b-form
                @submit.prevent="formSubmitted"
                @keydown="form.onKeydown($event)"
                class="row"
              >
                <b-col md="12" class="text-center">
                  <h5 class="contact-modal-title">Business Details</h5>
                  <hr />
                </b-col>
                <b-col md="6">
                  <b-form-group label="Company Name">
                    <b-form-input
                      type="text"
                      v-model="form.company_name"
                      placeholder="Company Name"
                      v-bind:class="{
                        'is-invalid': form.errors.has('company_name'),
                      }"
                    ></b-form-input>
                    <has-error :form="form" field="company_name"></has-error>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="ABN/ACN">
                    <b-form-input
                      type="text"
                      v-model="form.abn_acn"
                      placeholder="ABN/ACN"
                      v-bind:class="{
                        'is-invalid': form.errors.has('abn_acn'),
                      }"
                      @keyup="abnNumber"
                    ></b-form-input>
                    <has-error :form="form" field="abn_acn"></has-error>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Business Mobile Phone">
                    <b-form-input
                      type="text"
                      v-model="formattedBusinessPhone"
                      placeholder="Business Mobile Phone"
                      v-bind:class="{
                        'is-invalid': form.errors.has('business_phone'),
                      }"
                      @keyup="formatBusinessPhone"
                    ></b-form-input>
                    <has-error :form="form" field="business_phone"></has-error>
                  </b-form-group>
                </b-col>

                <b-col md="6">
                  <b-form-group label="Business Address">
                    <b-form-input
                      type="text"
                      v-model="form.business_address"
                      placeholder="Business Address"
                      v-bind:class="{
                        'is-invalid': form.errors.has('business_address'),
                      }"
                    ></b-form-input>
                    <has-error
                      :form="form"
                      field="business_address"
                    ></has-error>
                  </b-form-group>
                </b-col>
                <b-col md="12" class="text-right">
                  <b-button type="submit" variant="primary">Submit</b-button>
                </b-col>
              </b-form>
            </b-modal>
          </div>

          <div class="datagrid mb-4 mt-5">
            <div class="datagrid-body">
              <b-table
                :busy="this.$root.$data.bsLoader"
                :items="tableItems"
                :fields="tableFields"
                sort-icon-left
                hover
                responsive
                show-empty
              >
                <template v-slot:cell(status)="row">
                  <p
                    v-if="row.item.status == 'verified'"
                    style="
                      background-color: green;
                      padding: 6px 14px;
                      display: inline-block;
                      color: white;
                      font-size: 13px;
                      border-radius: 5px;
                    "
                  >
                    Verified
                  </p>
                  <p
                    v-else
                    style="
                      background-color: crimson;
                      padding: 6px 14px;
                      display: inline-block;
                      color: white;
                      font-size: 13px;
                      border-radius: 5px;
                    "
                  >
                    Not Verified
                  </p>
                </template>
                <template #empty class="text-center"> No Data Found </template>
              </b-table>
            </div>
            <div class="datagrid-footer" v-if="lastPage > 1">
              <b-pagination
                pills
                align="right"
                :total-rows="total"
                v-model="currentPage"
                :page-count="lastPage"
                :per-page="perPage"
                :hide-goto-end-buttons="true"
              ></b-pagination>
            </div>
          </div>
        </div>
      </div>
    <footer-component></footer-component>
    </b-container>

  </div>
  </b-overlay>
</template>

<script>
import NavBar from "../../includes/NavBar.vue";
import { Form, HasError } from "vform";
import _ from "lodash";
import moment from "moment";
import FooterComponent from "../../../includes/FooterComponent.vue";
import { Treeselect, ASYNC_SEARCH } from "@riophae/vue-treeselect";
import phoneNoMixin from "../../../../../mixins/phoneNoMixin.js";
import Swal from "sweetalert2";
import axios from "axios";

export default {
  components: {
    NavBar,
    FooterComponent,
    Treeselect,
    HasError,
  },
  props: {
    filterStatus: String,
  },
  mixins: [phoneNoMixin],
  data() {
    return {
      currentPage: 1,
      total: 0,
      perPage: 50,
      lastPage: 1,
      tableItems: [],
      tableFields: [
        { key: "company_name", sortable: true },
        { key: "phone", sortable: true },
        { key: "address", sortable: true, class: "table-td-width" },
        { key: "abn_acn", sortable: true },
        { key: "status", sortable: true },
        // { key: "action", sortable: false },
      ],
      form: new Form({
        id: this.$route.params.id,
        company_name: "",
        abn_acn: "",
        business_phone: "",
        business_address: "",
      }),
      filterQuery: "",
      showAddContactModal: false,
      formattedPhone: "",
      formattedBusinessPhone: "",
    };
  },
  mounted() {
    this.filter(1);
  },
  methods: {
    filter(page = 1) {
      this.$root.$data.bsLoader = true;
      axios
        .post("api/manager/contacts/private-contractor/filter", {
          page: page,
          per_page: 15,
          filter_query: this.filterQuery,
        })
        .then((response) => {
          this.currentPage = response.data.current_page;
          this.total = response.data.total;
          this.perPage = response.data.per_page;
          this.lastPage = response.data.last_page;

          this.tableItems = _.map(
            response.data.invited_private_contractors,
            (contractor) => {
              //Formatting Business Phone
              if (contractor.business_phone? contractor.business_phone.toString().length == 9:'') {
                var business_phone = "0" + contractor.business_phone;
              } else {
                var business_phone = contractor.business_phone;
              }

              return {
                id: contractor.id,
                company_name: contractor.company_name,
                abn_acn: contractor.abn_acn,
                phone: business_phone ? this.formatPhoneForAustraliaBySpace(business_phone) : "" ,
                address: contractor.business_address,
                status: contractor.abn_acn_status,
              };
            }
          );
        this.$root.$data.bsLoader = false;
        }).catch((err) => {
          this.$root.$data.bsLoader = false;
        });
    },
    addContactModal() {
      this.showAddContactModal = true;
    },
    abnNumber() {
      this.form.abn_acn = this.getABNACNDigitsOnly(this.form.abn_acn);
    },
    formatPhone() {
      this.form.phone = this.getPhoneDigitsOnly(this.formattedPhone);
      this.formattedPhone = this.formatPhoneForAustralia(this.form.phone);
    },
    formatBusinessPhone() {
      this.form.business_phone = this.getPhoneDigitsOnly(
        this.formattedBusinessPhone
      );
      this.formattedBusinessPhone = this.formatPhoneForAustralia(
        this.form.business_phone
      );
    },
    formSubmitted() {
      this.form
        .post("api/manager/contacts/private-contractor/updateOrCreate")
        .then((response) => {
          this.showAddContactModal = false;
          Swal.fire({
            title: "Contractor Added Successfully.",
            icon: "success",
            timer: 3000,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
          });

          this.filter(1);
          this.form.reset();
        })
        .catch((error) => {
          let errMsg = error.response.data.errors.abn_acn[0];
          if (
            errMsg ==
            "The abn/acn is already registered with some other business."
          ) {
            this.getAbnAcnDetails();
            this.form.reset();
          }
        });

        this.formattedBusinessPhone = "";
    },
    getAbnAcnDetails() {
      axios
        .post("api/manager/contacts/private-contractor/getAbnAcnDetails", {
          abn_acn: this.form.abn_acn,
        })
        .then((response) => {
          Swal.fire({
            title: "ABN/ACN Already Registered",
            html:
              "The ABN/ACN has already been registered to <b>" +
              response.data.business_details.company_name +
              "</b>. Do you want to add this in your contact lists?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "rgb(95, 46, 234)",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
          }).then((result) => {
           result.isConfirmed &&
            axios
              .post(
                "api/manager/contacts/private-contractor/save-existing-contractor",
                {
                  business_id: response.data.business_details.id,
                }
              )
              .then((response) => {
                if (result.isConfirmed) {
                  Swal.fire(
                    "Contractor Added in the contact lists.",
                    "",
                    "success"
                  );

                  this.filter(1);
                  this.showAddContactModal = false;
                  // Swal.fire("Contractor Added in the contact lists", "success");
                }
              });
          });
        });
    },
  },
  watch: {
    currentPage: {
      handler: function (value) {
        this.filter(value);
      },
    },
  },
};
</script>
<style scoped>
.body-wrapper {
  background-color: #f7f7fc !important;
  min-height: 100vh;
}

.table-btns {
  flex-wrap: wrap;
  gap: 0.75rem;
}

.work-order-btns {
  flex-wrap: wrap;
  gap: 0.5rem;
}

.table .favourite-th {
  color: red !important;
}
.table-td-width {
  max-width: 300px;
}
.modal-body {
  padding: 6px;
}
.btn-sm {
  padding: 0.55rem 1rem;
}
.favorite__heart {
  display: inline-block;
  padding: 3px;
  vertical-align: middle;
  line-height: 1;
  font-size: 20px;
  color: #ababab;
  cursor: pointer;
  -webkit-transition: color 0.2s ease-out;
  transition: color 0.2s ease-out;
}
.vue-treeselect__control {
  padding: 1rem 0.75rem !important;
}
.favorite__heart.is-disabled:hover {
  cursor: default;
}
.favorite__checkbox {
  position: absolute;
  overflow: hidden;
  clip: rect(0 0 0 0);
  height: 1px;
  width: 1px;
  margin: -1px;
  padding: 0;
  border: 0;
}
.favorite__heart__selected {
  color: #ffbc00;
}

footer {
    margin-top: 9rem;
    margin-bottom: 1rem;
}

.tbl-ct {
    display: flex;
    flex-wrap: wrap;
    column-gap: 1rem;
}


h5.contact-modal-title {
   font-size: clamp(1.3rem, 2vw, 1.75rem);
   font-weight: 400;
}


@media screen and (min-width: 800px) {
  .table-btns h5 {
    margin-left: auto;
  }

  .tbl-ct {
    justify-content: flex-end;
  }
}

@media screen and (max-width: 410px) {
    .tbl-ct .f-b {
        width: 100%;
    }
}

.modal-content {
    border-radius: 25px;
    padding: 1.5rem;
}
</style>
